<template>
  <div
    v-if="circle"
    class="rounded-circle d-flex align-center justify-center"
    style="width: 28px; height: 28px"
    :class="
      active
        ? ACTIVE_BACKGROUND_COLORS_BY_ENTITY[entityType]
        : BACKGROUND_COLORS_BY_ENTITY[entityType]
    "
  >
    <img
      v-if="entityType === 'rev'"
      alt="rever-isotype"
      :src="active ? reverIsotypeWhite : reverIsotype"
    />
    <v-icon
      v-else
      size="16"
      :color="active ? 'white' : ICON_COLORS_BY_ENTITY[entityType]"
    >
      {{ ICONS_BY_ENTITY[entityType] }}
    </v-icon>
  </div>
  <v-icon v-else :size="size" :color="ICON_COLORS_BY_ENTITY[entityType]">
    {{ ICONS_BY_ENTITY[entityType] }}
  </v-icon>
</template>

<script>
import reverIsotypeWhite from '@/assets/images/rever-isotype-all-white.svg'
import reverIsotype from '@/assets/images/rever-isotype-all-blue.svg'
export default {
  name: 'EntityIcon',

  props: {
    size: {
      type: [String, Number],
      default: 16,
    },
    circle: Boolean,
    entityType: {
      type: String,
      required: true,
    },
    active: Boolean,
  },

  data() {
    return {
      reverIsotype,
      reverIsotypeWhite,
      BACKGROUND_COLORS_BY_ENTITY: this.$constants.BACKGROUND_COLORS_BY_ENTITY,
      ICONS_BY_ENTITY: this.$constants.ICONS_BY_ENTITY,
      ICON_COLORS_BY_ENTITY: this.$constants.ICON_COLORS_BY_ENTITY,
      ACTIVE_BACKGROUND_COLORS_BY_ENTITY: this.$constants
        .ACTIVE_BACKGROUND_COLORS_BY_ENTITY,
    }
  },
}
</script>
